(function (global) {
  'use strict';
  if (global.FirelightBackInStock) return;
  var document = global.document;
  var states = new WeakMap();
  var selector = 'form[data-firelight-bis-form]';

  function variantId(form) {
    var section = form.closest('[id^="shopify-section-"]');
    if (section && section.querySelector('[data-atc-btn].is-variant-loading')) return '';
    var input = section && section.querySelector('[data-product-form] [data-variant-id]');
    var id = input && String(input.value || '').trim();
    return /^\d+$/.test(id) && Number(id) > 0 ? id : '';
  }
  function statusFor(form) {
    return document.getElementById(form.dataset.bisStatusId) || form.querySelector('[data-family-bis-status]');
  }
  function message(form, text) {
    var status = statusFor(form);
    if (status) { status.textContent = text; status.hidden = !text; }
  }
  function controls(form, busy) {
    var unavailable = !form.dataset.bisCompanyId;
    Array.from(form.elements).forEach(function (control) {
      if (!control.matches('[data-bis-control]')) return;
      control.disabled = unavailable;
      if (control.type === 'email') control.readOnly = busy;
      if (control.type === 'submit') control.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
    });
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
  function reset(form) {
    var previous = states.get(form);
    if (previous && previous.request) previous.request.abort();
    var state = { variant: variantId(form), request: null, acceptedEmail: '' };
    states.set(form, state);
    controls(form, false);
    var unavailable = form.id && document.getElementById(form.id + '-unavailable');
    if (unavailable) unavailable.hidden = !!form.dataset.bisCompanyId;
    message(form, '');
    return state;
  }
  function formsWithin(scope) {
    var forms = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) forms.unshift(scope);
    return forms;
  }
  function initialize(scope) {
    formsWithin(scope).forEach(function (form) { if (!states.has(form)) reset(form); });
  }
  function sync(scope) {
    formsWithin(scope).forEach(function (form) {
      var state = states.get(form);
      if (!state || state.variant !== variantId(form)) reset(form);
    });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches(selector)) return;
    // These are deliberately plain forms: there is no Shopify contact-form fallback.
    event.preventDefault();
    var state = states.get(form);
    var id = variantId(form);
    if (!state || state.variant !== id) state = reset(form);
    if (state.request) return;
    var email = form.elements.namedItem('email');
    if (!email || !form.reportValidity()) return;
    if (!id || !form.dataset.bisCompanyId) {
      message(form, 'Select a product option before requesting a notification.');
      return;
    }
    var address = email.value.trim();
    if (state.acceptedEmail === address) {
      message(form, 'You are registered for this selection’s stock notification.');
      return;
    }
    var request = new AbortController();
    state.request = request;
    controls(form, true);
    message(form, 'Submitting…');
    var timeout = global.setTimeout(function () { request.abort(); }, 15000);
    function current() { return form.isConnected && states.get(form) === state && variantId(form) === id; }
    var body = { data: {
      type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: address } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } } }
    } };
    global.fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(form.dataset.bisCompanyId), {
      method: 'POST', signal: request.signal,
      headers: { 'Content-Type': 'application/json', revision: '2026-07-15' }, body: JSON.stringify(body)
    }).then(function (response) {
      if (response.status !== 202) throw new Error('Subscription was not accepted.');
      if (current()) {
        state.acceptedEmail = address;
        message(form, 'You are registered for this selection’s stock notification.');
      }
    }).catch(function () {
      if (current()) message(form, 'Unable to register. Check your email and try again.');
    }).finally(function () {
      global.clearTimeout(timeout);
      if (states.get(form) === state) {
        state.request = null;
        if (form.isConnected) {
          if (variantId(form) !== id) reset(form);
          else controls(form, false);
        }
      }
    });
  });
  document.addEventListener('shopify:product:select', function (event) {
    var section = event.target.closest && event.target.closest('[id^="shopify-section-"]');
    if (!section) return;
    sync(section);
    if (event.promise) event.promise.then(function () { sync(section); }).catch(function () {});
  });
  // Family switching clones the product root; Shopify's editor also replaces sections.
  // Observe inserted/removed forms only, without rescanning unrelated vendor widgets.
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.removedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        formsWithin(node).forEach(function (form) {
          var state = states.get(form);
          if (!form.isConnected && state && state.request) state.request.abort();
        });
      });
      record.addedNodes.forEach(function (node) { if (node.nodeType === 1) initialize(node); });
    });
  });
  initialize(document);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  global.FirelightBackInStock = { initialize: initialize };
})(window);
